var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFeedback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 0H2.75C1.23 0 0 1.23 0 2.75V10.75C0 12.27 1.23 13.5 2.75 13.5H6V17.75C6 18.05 6.18002 18.33 6.46002 18.44C6.55002 18.48 6.65 18.5 6.75 18.5C6.94 18.5 7.14003 18.42 7.28003 18.28L12.06 13.5H16.75C18.27 13.5 19.5 12.27 19.5 10.75V2.75C19.5 1.23 18.27 0 16.75 0ZM18 10.75C18 11.44 17.44 12 16.75 12H11.75C11.55 12 11.36 12.08 11.22 12.22L7.5 15.94V12.75C7.5 12.34 7.16 12 6.75 12H2.75C2.06 12 1.5 11.44 1.5 10.75V2.75C1.5 2.06 2.06 1.5 2.75 1.5H16.75C17.44 1.5 18 2.06 18 2.75V10.75Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 4H4.75C4.34 4 4 4.34 4 4.75C4 5.16 4.34 5.5 4.75 5.5H14.75C15.16 5.5 15.5 5.16 15.5 4.75C15.5 4.34 15.16 4 14.75 4Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 7.32007H4.75C4.34 7.32007 4 7.66007 4 8.07007C4 8.48007 4.34 8.82007 4.75 8.82007H14.75C15.16 8.82007 15.5 8.48007 15.5 8.07007C15.5 7.66007 15.16 7.32007 14.75 7.32007Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeedback);
export default __webpack_public_path__ + "static/media/icon-feedback.75aa2aaad570c4de3185619cdb6190d3.svg";
export { ForwardRef as ReactComponent };